export default {
  APP: {
    BASE_URL: 'https://qiaroq-vue.web.app'
  },
  ANALYTICS: {
    GOOGLE: {
      ID: 'G-ZB94ELC6JL'
    }
  }
};
